(function () {
  'use strict';

  function PaymentController ($localStorage, $http, $sce, paymentFactory, $rootScope, $scope, Common,
    moment, $window, $location, $state, $q, Translation, progressTrackerFactory, paymentFormValidationFactory,
    MessageProxy, recipientsFactory, odrCalendarFactory, odrDistributionFactory, $translate, Browser) {
    const vm = this;

    // Temporary, will be reloaded, look below
    if (Common.exists('customer')) {
      vm.customers = [Common.get('customer')];
      vm.customer = Common.get('customer'); // Will be reset
    }

    vm.paymentMethod = Common.get('paymentMethod', 'CARD');

    if (vm.paymentMethod === 'INVOICE' && (!$rootScope.isNCPUser() || !web2print.env.invoiceForNCP || !vm.customer)) {
      vm.paymentMethod = 'CARD';
    }

    const addressInfoModel = {
      address: {},
      company: {},
      firstName: '',
      lastName: ''
    };

    const addressLimit = recipientsFactory.addressLimit;

    const recipients = {
      FILE: parseInt(Common.get('recipients.validAddressCount', 0)),
      COMPANIES: parseInt(Common.get('recipients.refinedAddressCount', 0)),
      INDIVIDUALS: parseInt(Common.get('recipients.refinedAddressCount', 0))
    };

    vm.referenceTranslateData = (function () {
      const product = Common.get('productDelivery', {});
      const pricingInfo = product.pricingInfo || {};
      const referenceSamples = (pricingInfo.deliveryOptions || {}).referenceSamples;
      if (referenceSamples) {
        return {
          copies: referenceSamples.copies,
          priceAndUnit: paymentFactory.addDecimalAndUnits(referenceSamples.price, $translate.instant(pricingInfo.units))
        };
      } else {
        return {};
      }
    })();

    vm.checkForWhiteSpaces = function () {
      // this will check for the address values
      // put this in factory if you think this method is resuable with other models
      const keys = ['street', 'zipcode', 'city'];

      keys.forEach(function (item) {
        if (!(/\S/.test(vm.addressInfo.address[item]))) {
          delete vm.addressInfo.address[item];
        }
      });
    };

    vm.selectCustomerMethod = function () {
      // TODO: Do we want to auto set payment to invoice when customer is selected?
      Common.set('customer', vm.customer);

      const streetName = vm.customer.postalAddress.streetName;
      const streetNumber = vm.customer.postalAddress.streetNumber;
      const poBox = vm.customer.postalAddress.pobox || '';
      // translating the "Postbox" word to be included in the input field
      const postBox = Translation.translate('PAYMENTS_PAGE_POSTBOX').value;

      vm.addressInfo.company.name = vm.customer.legalName;
      vm.addressInfo.company.organizationNumber = vm.customer.registrationNumber;
      vm.addressInfo.address.street = [streetName, streetNumber]
        .filter(function (value) {
          return value && value.length > 0;
        })
        .join(' ');
      vm.addressInfo.address.zipcode = (vm.customer.postalAddress.postalCode || '').replace(/\s/g, '');
      vm.addressInfo.address.city = vm.customer.postalAddress.city;

      if ((!streetName || streetName === '') && poBox && poBox !== '') {
        vm.addressInfo.address.street = postBox + ' ' + poBox;
      }

      vm.checkForWhiteSpaces();
      vm.saveContact();
      vm.checkOrderCompletion();
      checkCompanyInfoValidity();
    };

    vm.customerPlaceHolder = Translation.translate('POSTNORD_SELECT_CUSTOMER_NUMBER');

    vm.selectPaymentMethod = function () {
      Common.set('paymentMethod', vm.paymentMethod);

      if (vm.paymentMethod === 'INVOICE' && !$rootScope.isNCPUser()) {
        pnTopbar.login();
      }
    };

    vm.isNCP = function () {
      return $rootScope.isNCP;
    };

    vm.isNCPUser = function () {
      return $rootScope.isNCPUser();
    };

    vm.isPublicUserOrAnonymous = function () {
      return $rootScope.isPublicUserOrAnonymous();
    };

    vm.retrieveCustomers = function () {
      return $q(function (resolve, reject) {
        $http.get(web2print.env.validCustomerNumbersUrl)
          .success(function (response) {
            resolve(response.filter(function (item) {
              return (item.validSalesOrganizations || []).some(function (value) {
                return value === vm.product.salesOrganization;
              });
            }));
          })
          .error(function (error, response) {
            reject(); // TODO: display something
          });
      });
    };

    vm.loadCustomers = function () {
      return $q(function (resolve, reject) {
        if (vm.customers && vm.customers.length > 0)
          return resolve();

        vm.retrieveCustomers().then(function (customers) {
          if (customers.length === 0) {
            vm.customerPlaceHolder = Translation.translate('POSTNORD_NO_VALID_CUSTOMER_NUMBER');
            // This is a ugly hack to remove the selection dialog when empty
            const container = angular.element(document.getElementsByClassName('md-select-menu-container'));
            const mask = angular.element(document.getElementsByClassName('md-scroll-mask'));
            const backdrop = angular.element(document).find('md-backdrop');
            backdrop.remove();
            mask.remove();
            container.remove();
          }
          vm.customers = customers;
          resolve();
        });
      });
    };

    if (Common.exists('customer')) {
      vm.retrieveCustomers()
        .then(function (customers) {
          const stored = Common.get('customer');
          const found = customers.find(function (value) {
            return value.customerNumber === stored.customerNumber;
          });

          vm.customers = customers;
          vm.customer = found ? found : undefined;
        });
    }

    function placeOrder () {
      vm.showErrorMessages = false;
      const params = paymentFactory.buildPlaceOrderParams();
      if (vm.paymentMethod)
        params.paymentMethod = vm.paymentMethod;
      if (vm.paymentMethod === 'INVOICE' && !web2print.env.invoiceForNCP)
        vm.paymentMethod = 'CARD';
      if (vm.customer)
        params.customerNumber = vm.customer.customerNumber;

      delete params.senderInfo.company;
      params.contactInfo = paymentFactory.buildContactInfo(vm.currentForm);
      params.redirectUrl = $rootScope.baseUrl + '/#/payment-redirect';

      paymentFactory.setPaymentResponseCode('None');
      vm.placeOrderFailed = false;

      $http.post(web2print.env.ordersBaseUrl + 'placeOrder', params)
        .success(function (response) {
          console.log(response);
          Common.set('orderId', response.orderId);
          Common.set('cartId', response.cartId);

          if (response.url)
            $window.location.href = response.url;
        }).error(function (error, response) {
          vm.isSubmitting = false;
          vm.placeOrderFailed = true;
          vm.showErrorMessages = error.errorMessage.validOrder;

          console.log(error);
        });
    }

    function getPaymentMethods () {
      paymentFactory.getPaymentMethods(pnTopbar.market)
        .then(function (res) {
          vm.paymentMethods = {};
          res.availablePaymentMethods.forEach(function (paymentMethod) {
            paymentMethod.show = true;
            vm.paymentMethods[paymentMethod.paymentMethodId] = paymentMethod;
          });
        }, function (err) {
          console.log(' Falied to get Payment methods: ' + err);
        });
    }

    function getDateTime () {
      return moment(vm.product.deliveryDate).format('DD MMM');
    }


    function checkOrderCompletion () {
      return paymentFactory.checkCompletion(vm.termsApproved);
    }

    function switchForm (form) {
      if (!vm.isSubmitting) {
        Common.set('paymentForm', vm.currentForm = form);
        vm.addressInfo = $localStorage.addressInfo ? angular.copy($localStorage.addressInfo) : angular.copy(Common.get('addressInfo', angular.copy(addressInfoModel)));
      }
    }

    function submit () {
      Common.set('addressInfo', vm.addressInfo);
      Common.set('paymentMethod', vm.paymentMethod);
      if (vm.referenceAddress) {
        Common.set('referenceAddressInfo', vm.referenceAddressInfo);
      }

      vm.isSubmitting = true;
      placeOrder();
    }

    function updatePaymentPriceDetails () {
      vm.paymentDetails = paymentFactory.extractCalculatedPrice();
    }

    function copyAddress () {
      if (vm.isCopyingAddress) {
        vm.referenceAddressInfo = angular.copy(vm.addressInfo);
        Common.set('referenceAddressInfo', vm.referenceAddressInfo);
      }
    }

    function onChangeReferenceAddressForm () {
      if (JSON.stringify(vm.referenceAddressInfo) !== JSON.stringify(vm.addressInfo)) {
        vm.isCopyingAddress = false;
      }

      Common.set('referenceAddressInfo', vm.referenceAddressInfo);
    }

    function getResponseCode () {
      return paymentFactory.getPaymentResponseCode();
    }

    function goBack () {
      if (!vm.isSubmitting) {
        $state.go('main.message');
      }
    }

    function compareAddresses () {
      let same = true;
      const contactAddress = Common.get('addressInfo', {});
      const referenceAddress = Common.get('referenceAddressInfo', {});
      const addressKeys = ['address', 'company', 'firstName', 'lastName'];

      addressKeys.forEach(function (key) {
        if (key === 'company' && !contactAddress.company) {
          delete referenceAddress.company;
          return;
        }

        if ((contactAddress[key] || '').toString() !== (referenceAddress[key] || '').toString()) {
          same = false;
        }
      });

      return same;
    }

    function referenceCheckStatus () {
      if (!vm.referenceAddress) {
        vm.isCopyingAddress = false;
        vm.referenceAddressInfo = angular.copy(addressInfoModel);
        Common.set('referenceAddressInfo', null);
      }

      Common.set('addReferences', vm.referenceAddress);
      Common.notifyObserver('web2print.pricing');
    }

    function saveContact () {
      Common.set('addressInfo', vm.addressInfo);
      Common.set('referenceAddress', vm.referenceAddressInfo);
      storeContactInfo(vm.isStoreContactInfo);
    }

    function storeContactInfo (store) {
      if (store) {
        $localStorage.addressInfo = angular.copy(vm.addressInfo);
      } else {
        delete $localStorage.addressInfo;
      }
    }

    function checkCompanyInfoValidity () {
      const criterias = {
        name: ['Length'],
        organizationNumber: ['Length', 'Pattern']
      };

      Object.keys(criterias).forEach(function (key) {
        // contactPerson is a user input, should use the angularjs validation for this
        if (key !== 'contactPerson') {
          vm.companyInfoValidity = paymentFormValidationFactory.checkModel(vm.addressInfo.company[key], criterias[key],
            key, vm.companyInfoValidity);
        }
      });

      vm.companyInfoValidity = paymentFormValidationFactory.checkCommonFieldsValidity(vm.companyInfoValidity,
        vm.addressInfo.address);
      vm.companyInfoAllValid = JSON.stringify(vm.companyInfoValidity).indexOf('false') === -1;

      if (!$scope.$$phase) {
        $scope.$apply();
      }
    }

    function extractUserProfile () {
      let senderInfo = Common.get('addressInfo', {});
      const userInfo = Common.get('userProfile', null);

      if (userInfo && !Object.keys(senderInfo).length && vm.currentForm === 'private') {
        senderInfo = angular.copy(addressInfoModel);
        senderInfo.firstName = userInfo.firstName;
        senderInfo.lastName = userInfo.lastName;
        senderInfo.address.street = '';
        senderInfo.address.zipcode = '';
        senderInfo.address.city = '';
        senderInfo.email = userInfo.email;
        Common.set('addressInfo', senderInfo);
      }

      if ((!userInfo && !Object.keys(senderInfo).length) || (userInfo && !Object.keys(senderInfo).length && vm.currentForm === 'company')) {
        senderInfo = angular.copy(addressInfoModel);
      }

      return senderInfo;
    }

    function canSubmit (form) {
      let validCustomer = true;

      console.log(`paymentSolution: ${Common.get('productDelivery').paymentSolution}`);

      if (Common.get('productDelivery').paymentSolution === 'ODR') {
        validCustomer = angular.isDefined(vm.customer);
      }

      console.log(`vm.checkOrderCompletion() : ${vm.checkOrderCompletion() }`);
      console.log(`vm.companyInfoAllValid : ${vm.companyInfoAllValid}`);
      console.log(`!vm.isSubmitting : ${!vm.isSubmitting}`);
      console.log(`vm.product.numberOfRecipients >= addressLimit().min : ${vm.product.numberOfRecipients >= addressLimit().min}`);
      console.log(`(addressLimit().max : ${(addressLimit().max)}`);
      console.log(validCustomer);

      return vm.checkOrderCompletion() &&
        vm.companyInfoAllValid &&
        form.$valid &&
        !vm.isSubmitting &&
        vm.product.numberOfRecipients >= addressLimit().min &&
        (addressLimit().max ? vm.product.numberOfRecipients <= addressLimit().max : true) &&
        validCustomer;
    }

    function isReadOnlyMode () {
      return window.pnTopbar.readOnlyMode;
    }

    function getPostalMask () {
      const masks = {
        SE: '999 99',
        DK: '9999'
      };

      return masks[pnTopbar.market || 'SE'];
    }

    function getPostalErrorByMarket () {
      const messages = {
        SE: 'RECIPIENTS_PAGE_ERROR_POSTAL_LENGTH',
        DK: 'RECIPIENTS_PAGE_ERROR_POSTAL_LENGTH_DK'
      };

      return messages[pnTopbar.market || 'SE'];
    }

    function availableForCurrentMarket (paymentType) {
      const paymentTypes = {
        INVOICE: ['SE']
      };

      return paymentTypes[paymentType].indexOf(pnTopbar.market || 'SE') > -1;
    }

    function activate () {
      // Models
      vm.invoiceForNCP = web2print.env.invoiceForNCP;
      vm.currentForm = vm.isNCPUser() ? 'company' : Common.get('paymentForm', 'private');
      vm.language = pnTopbar.language;
      vm.hideSpec = true;
      vm.disableInvoice = true;
      vm.isSubmitting = false;
      vm.termsApproved = false;
      vm.companyInfoAllValid = true;
      vm.product = Common.get('productDelivery');
      vm.getExtraCopies = getExtraCopies();
      vm.paymentDetails = paymentFactory.extractCalculatedPrice();
      vm.pdf = '';
      vm.materialDetails = Common.get('materialDetails', {});
      vm.sendoutName = Common.get('sendoutName', '');
      vm.placeOrderFailed = false;
      vm.referenceAddress = Common.get('addReferences', false);
      vm.isCopyingAddress = vm.referenceAddress && Common.get('referenceAddressInfo', false) ? compareAddresses() : false;
      vm.isStoreContactInfo = $localStorage.addressInfo ? true : false;
      vm.addressInfo = $localStorage.addressInfo ? angular.copy($localStorage.addressInfo) : extractUserProfile();
      vm.referenceAddressInfo = Common.get('referenceAddressInfo', angular.copy(addressInfoModel));
      vm.isPaymentPage = true;
      vm.isSTF = Common.get('serviceType') !== 'admail-odr';

      const serviceType = Common.get('serviceType');
      const addressType = Common.get('recipients.addressType');
      const targetType = Common.get('recipients.targetType', 'FILE');

      paymentFactory.fetchProductTerms(vm.product).then(function (res) {
        vm.termsOfService = res.url;
      }, function (err) {
        console.log(err);
      });

      vm.whatToSend = getWhatToSendDescription(serviceType, addressType, targetType) || 'INFORMATION_DESCRIPTION';

      if (Common.get('serviceType') !== 'admail-odr') {
        vm.showReferenceAddress = vm.product.pricingInfo.deliveryOptions.referenceSamples;
      }

      vm.formIsClean = true;
      vm.companyInfoValidity = {
        nameLength: true,
        streetLength: true,
        organizationNumberLength: true,
        organizationNumberPattern: true,
        zipcodeLength: true,
        zipcodeNumber: true,
        cityLength: true
      };

      vm.product.numberOfRecipients = recipients[targetType];

      vm.showErrorMessages = false; // this is for showing different kinds of errors. this will be converted to object if there is an error in validation

      // methods
      vm.getDateTime = getDateTime;
      vm.submit = submit;
      vm.checkOrderCompletion = checkOrderCompletion;
      vm.switchForm = switchForm;
      vm.copyAddress = copyAddress;
      vm.onChangeReferenceAddressForm = onChangeReferenceAddressForm;
      vm.getResponseCode = getResponseCode;
      vm.goBack = goBack;
      vm.referenceCheckStatus = referenceCheckStatus;
      vm.saveContact = saveContact;
      vm.storeContactInfo = storeContactInfo;
      vm.checkCompanyInfoValidity = checkCompanyInfoValidity;
      vm.canSubmit = canSubmit;
      vm.isReadOnlyMode = isReadOnlyMode;
      vm.getSubmissionDeadline = odrCalendarFactory.getSubmissionDeadline;
      vm.getSelectedTerminal = odrDistributionFactory.getSelectedTerminal;
      vm.getExtraCopies = getExtraCopies;
      vm.getPostalMask = getPostalMask;
      vm.getPostalErrorByMarket = getPostalErrorByMarket;
      vm.tcLanguageExclusive = tcLanguageExclusive;
      vm.availableForCurrentMarket = availableForCurrentMarket;

      if (vm.addressInfo.company) {
        if (Object.keys(vm.addressInfo.company).length) {
          vm.formIsClean = false;
          checkCompanyInfoValidity();
        }
      }

      function getExtraCopies () {
        //const targetType = Common.get('recipients.targetType', null);
        const recipients = vm.product.numberOfRecipients;

        let extraCopies = 0;

        if (recipients <= 1000) {
          extraCopies = 50;
        } else if (recipients >= 1001 && recipients <= 5000) {
          extraCopies = 70;
        } else if (recipients >= 5001 && recipients <= 10000) {
          extraCopies = 150;
        } else if (recipients >= 10001 && recipients <= 500000) {
          extraCopies = Math.round(recipients * 0.015);
        }
        return extraCopies;
      }

      getPaymentMethods();
      if (serviceType !== 'admail-odr') {
        generatePdfPreview();
      }
      console.log('PaymentController activated');

      // register observers
      Common.registerObserver('updatePaymentPriceDetails', updatePaymentPriceDetails);

      // listeners
      $scope.$on('changeLanguage', function (ev, language) {
        vm.language = language;
        Common.notifyObserver('web2print.pricing');
        moment.locale(language);
      });

    }

    function generatePdfPreview () {

      function callback (finished, state) {
        if (finished && state === -1) {
          throw 'An error occurred while generating preview';
        }

        console.log('Generated new pdf presigned url.');
      }

      MessageProxy.getPdfContent(Common.get('s3Pdf'))
        .then(function (response) {

          let fileURL = URL.createObjectURL(new Blob([response], {
            type: 'application/pdf'
          }));

          if (Browser.checkIEVersion()) {
            fileURL = Common.get('s3Pdf');
          }

          vm.pdf = $sce.trustAsResourceUrl(fileURL);

        })
        .catch(function (error) {

          // re-generate preview
          if (error.status === 400) {
            const options = MessageProxy.generatePreviewParams();

            MessageProxy.generatePreview(options, callback)
              .then(function (url) {
                Common.set('s3Pdf', url);
                Common.set('pristine', true);

                generatePdfPreview();
              })
              .catch(function (error) {
                goBack();
              });

          } else {
            goBack();
          }
        });
    }

    function tcLanguageExclusive (market) {
      const displayConditions = {
        SE: vm.language !== 'sv' && !vm.product.termsOfServices[vm.language],
        DK: vm.language !== 'da' && !vm.product.termsOfServices[vm.language],
      };

      return displayConditions[market] && pnTopbar.market === market;
    }

    function getWhatToSendDescription (serviceType, addressType, targetType) {
      let message = null;

      switch (serviceType) {
        case 'information':
          message = 'INFORMATION_DESCRIPTION';
          break;
        case 'paymentSlips':
          message = 'PAYMENT_SLIPS_DESCRIPTION';
          break;
        case 'admail-letter':
          if (addressType === 'ADR') {
            message = (targetType === 'INDIVIDUALS') ? 'ADMAIL_LETTER_ADR_INDIVIDUALS_DESCRIPTION' : 'ADMAIL_LETTER_ADR_FILE_DESCRIPTION';
          } else {
            message = 'ADMAIL_FLYER_DESCRIPTION';
          }
          break;
        case 'admail-postcard':
          if (addressType === 'ADR') {
            if (targetType === 'INDIVIDUALS') {
              message = 'ADMAIL_POSTCARD_ADR_INDIVIDUALS_DESCRIPTION';
            } else {
              message = 'ADMAIL_POSTCARD_ADR_FILE_DESCRIPTION';
            }
          } else {
            message = 'ODR_DESCRIPTION';
          }
          break;
        default:
          message = null; //FIXME Unknown service type. Need to set default
          break;
      }

      return message;
    }

    function checkSession () {
      const action = {
        0: angular.noop,
        1: Common.resetOrderData
      };

      if (!Common.get('materialDetails', null) || Common.get('paymentStatus', false) === 'SUCCESS') {
        action[Number(Common.get('orderId', null) !== null)]();
        $location.path('/');
        return;
      }

      if (!progressTrackerFactory.checkAll()) {
        const path = progressTrackerFactory.getContinuePath();

        $location.path(path);
        return;
      }

      // get date exceptions again, just in case the page was being refreshed
      odrDistributionFactory.getExceptionDates()
        .then((res) => {
          odrCalendarFactory.dateExceptions = res.result;
        });
      // no need to wait for the request to be done
      activate();
    }

    checkSession();

  }

  angular.module('web2print.payment')
    .controller('PaymentController', PaymentController);

  PaymentController.$inject = ['$localStorage', '$http', '$sce', 'paymentFactory', '$rootScope', '$scope', 'Common', 'moment', '$window', '$location', '$state', '$q', 'Translation', 'progressTrackerFactory', 'paymentFormValidationFactory', 'MessageProxy', 'recipientsFactory', 'odrCalendarFactory', 'odrDistributionFactory', '$translate', 'Browser'];
})();
